import useModal from 'hooks/useModal/useModal';
import React from 'react';
import UIModal from 'ui/atoms/Modal/Modal';
import ChangeGroupExternalUser from './variants/ChangeGroupExternalUser';
import CreateExportAccessEvents from './variants/CreateExportAccessEvents';
import DeleteExternalUser from './variants/DeleteExternalUser';
import DeleteExternalUserGroup from './variants/DeleteExternalUserGroup';
import DeleteInstaller from './variants/DeleteInstaller';
import DeleteLockGroup from './variants/DeleteLockGroup';
import DisconnectMobileDevice from './variants/DisconnectMobileDevice';
import EditSchedule from './variants/EditSchedule';
import ManageLockGroup from './variants/LockGroup/ManageLockGroup';
import PreparingExportAccessEvents from './variants/PreparingExportAccessEvents';
import RemoveOrganizationFromMobileApp from './variants/RemoveOrganizationFromMobileApp';
import ResendInvitation from './variants/ResendInvitation';

const Modal: React.FC<React.PropsWithChildren> = () => {
  const { modalState } = useModal();

  const renderCorrectVariant = () => {
    switch (modalState?.type) {
      case 'disconnectMobileDevice':
        return <DisconnectMobileDevice />;
      case 'removeOrganizationFromMobileApp':
        return <RemoveOrganizationFromMobileApp />;
      case 'deleteExternalUser':
        return <DeleteExternalUser />;
      case 'editSchedule':
        return <EditSchedule />;
      case 'deleteExternalUserGroupNew':
        return <DeleteExternalUserGroup />;
      case 'changeGroupExternalUser':
        return <ChangeGroupExternalUser />;
      case 'deleteInstaller':
        return <DeleteInstaller />;
      case 'resendInvitation':
        return <ResendInvitation />;
      case 'manageLockGroup':
        return <ManageLockGroup />;
      case 'deleteLockGroup':
        return <DeleteLockGroup />;
      case 'createExportAccessEvents':
        return <CreateExportAccessEvents />;
      case 'preparingExportAccessEvents':
        return <PreparingExportAccessEvents />;
      default:
        return null;
    }
  };
  return modalState?.type ? <UIModal>{renderCorrectVariant()}</UIModal> : <></>;
};

export default Modal;
